/**
 * Renders a stored phone number for display: `+16282228031` becomes
 * `+1 (628) 222-8031`. Only North American numbers are regrouped — any other
 * number is returned as stored, because a wrong grouping reads worse than none.
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return "";

  const digits = phone.replace(/\D/g, "");
  if (phone.trim().startsWith("+") && !digits.startsWith("1")) return phone;

  const nanp = digits.match(/^1?(\d{3})(\d{3})(\d{4})$/);
  if (!nanp) return phone;

  const [, area, exchange, line] = nanp;
  return `+1 (${area}) ${exchange}-${line}`;
}
